@if (show) {
<div
  class="fixed inset-0 flex items-center justify-center bg-black/80 bg-opacity-50 z-50 transition-opacity duration-300"
>
  <div class="bg-white rounded-lg shadow-lg p-6 relative">
    <h1 class="text-lg font-semibold mb-4">{{ title }}</h1>
    <button (click)="onClose()" class="absolute top-2 right-2 text-gray-500 hover:text-gray-800">
      <img
        src="/icons/close.svg"
        alt="close"
        class="w-5 h-5 cursor-pointer hover:bg-secondary rounded"
      />
    </button>
    <ng-content></ng-content>
  </div>
</div>
}
